<div class="img-container border-radius d-flex flex-column primary-bg-300 overflow-hidden">
    <ng-content></ng-content>
</div>
